<template>
    <common-card class="mt-3">
        <v-row>
            <v-col>
                <v-row style="padding: 15px 20px 0px 20px">
                    <v-col cols="12" md="6">
                        <h1>Administrador de Disposiciones Outbound Ventas</h1>
                    </v-col>
                    <v-col cols="12" md="6" style="text-align: end">
                        <v-btn class="common-botton" dark :loading="loading" @click="openModal(true)">
                            <v-icon class="mr-2">mdi-plus</v-icon>
                            <span>Nueva</span>
                        </v-btn>
                        &nbsp;&nbsp;
                        <v-btn class="common-botton" dark :loading="loading" @click="openModalCargaMasiva()">
                            <v-icon class="mr-2">mdi-plus</v-icon>
                            <span>Carga Masiva</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-expansion-panels elevation="0" style="padding: 30px; border-radius: 20px">
            <v-expansion-panel>
                <v-expansion-panel-header style="padding: 35px">
                    <h3 style="color: #42352e">Búsqueda detallada</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="4">
                            <v-autocomplete v-model="filtros.campania_id" :items="campanias" item-text="producto"
                                item-value="id" label="Campaña" outlined dense color="primary" background-color="white">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                            <v-autocomplete v-model="filtros.status" label="Estatus" :items="status" item-text="label"
                                item-value="value" outlined dense color="primary" background-color="white">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                            <v-autocomplete v-model="filtros.disposicion" label="Disposición"
                                :items="dispocicionesfilterBusqueda" item-text="disposicion" item-value="disposicion"
                                outlined dense color="primary" background-color="white">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row style="padding: 0px 40px 0px 40px" class="d-flex justify-end">
                        <v-col cols="12" md="2">
                            <v-btn dark block outlined color="#00a7e4" rounded @click="clearFilters()">
                                Limpiar
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="2" style="text-align: end">
                            <v-btn class="common-botton" dark block :disabled="filtersIncomplete" :loading="loading"
                                @click="getDisopocicionesFilter(true)">
                                <span>Filtrar</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div style="padding: 0px 40px 0px 40px">
            <hr />
        </div>
        <v-row>
            <v-col cols="12" class="mb-10" style="padding: 40px">
                <v-data-table style="" :headers="plantillasTable" @pagination="pagination"
                    :server-items-length="totalItems" :items="disposicionesResult" item-key="id" class="elevation-0"
                    :loading="loading" loading-text="Cargando..."
                    no-data-text="Para ver elementos, primero realiza una búsqueda">
                    <template v-slot:top>
                        <v-row style="padding: 15px">
                            <v-col cols="8">
                                <h2>Resultados de la búsqueda</h2>
                            </v-col>
                            <v-col cols="4" style="text-align: end">
                                <v-btn class="common-botton" dark :loading="loading" @click="downloadReport"
                                    v-if="disposicionesResult.length > 0">
                                    <span>Descargar</span>
                                    <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>

                    <template v-slot:item.campaniaNombre="{ item }">
                        <span>{{ getCampaniaName(item.campania.campania_id) }}</span>
                    </template>

                    <template #item.fechaCreacion="{ item }">
                        <span>{{ moment(item.fechaRegistro).format("DD/MM/YYYY") }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                        <div>
                            <v-chip :color="item.campania.status == 1
                                    ? 'green'
                                    : item.campania.status == 2
                                        ? 'amber darken-2'
                                        : 'red'
                                " dark>{{ getEstatusName(item.campania.status) }}</v-chip>
                        </div>
                    </template>
                    <template v-slot:item.uuid="{ item }">
                        <v-icon small class="mr-2" @click="openModal(false, item.campania.disposicion_id)">
                            mdi-eye
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <EditCreateCampainDispociscinesModal v-if="dialog" v-show="dialog" :dialog="dialog" :route="route"
            :idCampaing="idCampaing" @successCampaing="successModal" @closeModal="dialog = false" />

        <CargaMasivaDispocicionesOutbound v-if="dialogCargaMasiva" v-show="dialogCargaMasiva"
            :dialog="dialogCargaMasiva" :idCampaing="idCampaing" :campanias="campanias" @successCampaing="successModal"
            @closeModal="dialogCargaMasiva = false" />
    </common-card>
</template>

<script>
import { mainAxios } from "../../../../mainAxios";
import moment from "moment";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import CargaMasivaDispocicionesOutbound from "@/components/commonComponents/dialogs/CargaMasivaDispocicionesOutbound.vue";

export default {
    components: {
        CommonCard,
        EditCreateCampainDispociscinesModal: () =>
            import(
                "@/components/commonComponents/dialogs/EditCreateCampainDispociscinesModal.vue"
            ),
        CargaMasivaDispocicionesOutbound,
    },
    data() {
        return {
            moment,
            templates: [],
            totalItems: 0,
            rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
            roles: JSON.parse(localStorage.getItem("roles")),
            areas: [],
            ramos: [],
            canales: [],
            status: [
                { label: "Activo", value: 1 },
                { label: "Inactivo", value: 2 },
            ],
            loading: false,
            search: "",
            filtros: {
                campania_id: null,
                disposicion: null,
                status: null,
                //pagina: 1,
                //elementosPagina: 10,
            },
            plantillasTable: [
                {
                    text: "Id",
                    align: "start",
                    sortable: false,
                    value: "campania.disposicion_id",
                },
                { text: "Estatus", value: "status" },
                { text: "Campaña", value: "campaniaNombre" },
                { text: "Disposicion", value: "disposicion.disposicion" },
                { text: "Tipo", value: "disposicion.tipo_contacto" },
                { text: "Ver", value: "uuid" },
            ],
            report: [],
            campanias: [],
            dispocicionesfilterBusqueda: [],
            dialog: false,
            disposicionesResult: [],
            dialogCargaMasiva: false,
            primerInicio: false,
        };
    },

    watch: {
        $route() { },
        "filtros.campania_id"(newValue) {
            if (newValue !== null) {
                this.getDisopocicionesFilter();
            }
        },
    },

    computed: {
        canViewCreate() {
            let canView = false;
            let roles = [];
            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesToView = [
                "ADMIN",
                "ADMINCC",
                "ADMINCCALIANZAS",
                "MANAGERCC",
                "MANAGERCCALIANZAS",
            ];
            roles.forEach((element) => {
                if (rolesToView.includes(element)) {
                    canView = true;
                }
            });
            return canView;
        },
        //validad filtros completos
        filtersIncomplete() {
            return Object.values(this.filtros).every((v) => v === null);
        },
    },

    methods: {
        clearFilters() {
            if (!this.filtros) this.filtros = {};
            Object.assign(this.filtros, {
                campania_id: null,
                disposicion: null,
                status: null,

                //pagina: 1,
                //elementosPagina: 10,
            });
            this.disposicionesResult = [];
        },
        pagination() {
            /*this.filtros.pagina = event.page;
            this.filtros.elementosPagina = event.itemsPerPage;
            if (this.primerInicio) {
            }*/
        },
        getCampanias() {
            this.loading = true;

            mainAxios
                .post(
                    "/v1/campania/filters",
                    //  { area_negocio_id: localStorage.area_negocio_id, },
                    { area_negocio_id: [1] },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.agenteAccessToken}`,
                        },
                    }
                )
                .then((res) => {
                    this.totalItems = res.data.count;
                    this.campanias = res.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.campanias = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getCampaniaName(id) {
            //Para traer el nombre de campaña en el la tabla
            const campania = this.campanias.find((c) => c.id === id);
            return campania ? campania.producto : "Desconocido";
        },

        getEstatusName(status) {
            //Para traer el nombre de campaña en el la tabla
            return status === 1 ? "Activo" : "Inactivo";
        },

        getDisopocicionesFilter(defiltrar = false) {
            this.loading = true;
            mainAxios
                .post("/v1/disposiciones_outbound/filter", this.filtros, {
                    headers: {
                        Authorization: `Bearer ${localStorage.agenteAccessToken}`,
                    },
                })
                .then((res) => {
                    //si estas todos los filtros mostramos datos en la tabla
                    if (defiltrar) {
                        this.disposicionesResult = res.data;
                        return;
                    }
                    this.totalItems = res.data.count;
                    const seenDisposiciones = new Set();
                    this.dispocicionesfilterBusqueda = res.data.reduce((list, item) => {
                        const dispo = item?.disposicion?.disposicion;
                        if (dispo && !seenDisposiciones.has(dispo)) {
                            seenDisposiciones.add(dispo);
                            list.push({ disposicion: dispo });
                        }
                        return list;
                    }, []);
                })
                .catch((err) => {
                    console.error(err);
                    this.dispocicionesfilterBusqueda = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        downloadReport() {
            this.loading = true;
            mainAxios
                .post("/v1/disposiciones_outbound/report", this.filtros, {
                    headers: {
                        Authorization: `Bearer ${localStorage.agenteAccessToken}`,
                    },
                    responseType: "blob",
                })
                .then((res) => {
                    // create a temporary <a> and click it
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Reporte_disposiciones_outbound.csv");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((err) => console.error(err))
                .finally(() => (this.loading = false));
        },

        openModal(isNew = false, idCampaing) {
            if (isNew) {
                this.route = "v1/???'/insert";
                this.idCampaing = null;
            } else {
                this.route = "v1/???/update/" + idCampaing;
                this.idCampaing = idCampaing;
            }
            this.dialog = true;
        },
        openModalCargaMasiva() {
            this.dialogCargaMasiva = true;
        },
        successModal() {
            this.dialog = false;
            this.clearFilters();
        },
    },
    async mounted() {
        await this.getCampanias();
    },
};
</script>
<style scoped>
.theme--light.v-data-table {
    background-color: #f2fafc;
    color: rgba(0, 0, 0, 0.87);
    border-radius: 20px;
}

.v-expansion-panel {
    border-radius: 20px;
}

.v-expansion-panels {
    z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active {
    border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
    background-color: #f6f5f9;
    color: rgba(0, 0, 0, 0.87);
}
</style>